import { $t } from '~/composables/useTexts';

export default defineNuxtPlugin(() => {
  return {
    provide: {
      t: $t,
    },
  };
});
